import { defaultTheme } from '@agro-club/agroclub-shared'
import { BidTypes } from 'modules/domain/bid/types'
import { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { AAntdTabs } from 'views/components/Analytics'
import { BidDetailBlock } from '../BidDetailBlock'
import { BidWarehouseBlock } from '../BidDetailBlock/BidWarehouseBlock/BidWarehouseBlock'
import { useDealContext } from '../DealContext'

const Wrapper = styled.div`
  background: ${defaultTheme.color.backgroundSecondary};
  border-radius: 16px;
  padding-top: 28px;
  .ant-tabs-nav {
    padding: 0 16px;
  }
`

export const MobileBids: FC = () => {
  const { t } = useTranslation('deal')
  const { deal, dealRefetch, whMovements } = useDealContext()
  const [activeTab, setActiveTab] = useState<string>()
  const isVisibleWarehouse = deal.purchase_bid.is_for_warehouse && deal.has_warehouse_movements

  const customerTab = useMemo(
    () =>
      isVisibleWarehouse
        ? {
            warehouse: {
              label: t('warehouses:warehouse'),
            },
          }
        : {
            [BidTypes.purchase]: {
              label: t('buyer'),
            },
          },
    [isVisibleWarehouse, t],
  )

  const tabItems = useMemo(() => {
    const initialTabsData = {
      [BidTypes.sale]: {
        label: t('seller'),
      },
      ...customerTab,
    }

    const tabs: any = []
    for (const key of Object.keys(initialTabsData)) {
      tabs.push({
        label: initialTabsData[key].label,
        key,
        children:
          isVisibleWarehouse && key === 'warehouse' ? (
            <BidWarehouseBlock whMovements={whMovements} dealId={deal.id} dealRefetch={dealRefetch} />
          ) : (
            <BidDetailBlock key={key} bidType={BidTypes[key]} />
          ),
      })
    }
    return tabs
  }, [t, customerTab, isVisibleWarehouse, whMovements, deal, dealRefetch])

  useEffect(() => {
    if (isVisibleWarehouse && activeTab === BidTypes.purchase) {
      setActiveTab('warehouse')
    }
    if (!isVisibleWarehouse && activeTab === 'warehouse') {
      setActiveTab(BidTypes.purchase)
    }
  }, [activeTab, isVisibleWarehouse])

  return (
    <Wrapper>
      <AAntdTabs
        id="bidTabs"
        defaultActiveKey={BidTypes.sale}
        items={tabItems}
        onChange={(tab) => setActiveTab(tab)}
        activeKey={activeTab}
      />
    </Wrapper>
  )
}
